import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
  Table,
} from "antd";
import styled from "styled-components";
import dayjs from "dayjs";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { RightOutlined } from "@ant-design/icons";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import { DeleteOutlineOutlined } from "@mui/icons-material";
import COLORS from "common/Colors";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllDepartmentList,
  getLoadNewList,
  getUserInfo,
} from "redux/selectors";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";
import { setLoadNewList } from "redux/actions";

const { Option } = Select;

const StyledTable = styled(Table)`
  .ant-table {
    border: 1px solid #ccc;
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 12px;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 900px;
  }

  .ant-table-cell {
    padding: 16px;
    white-space: nowrap;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .ant-table-tbody > tr > td {
    border-bottom: none !important;
  }

  .reason-column {
    min-width: 280px;
    white-space: normal;
  }

  .non-white {
    background: #f9f9f9;
  }

  @media (max-width: 768px) {
    .ant-table-cell {
      padding: 10px;
      font-size: 12px;
    }
  }
`;

const Wrapper = styled.div`
  position: relative;
  height: calc(100vh - 150px);
  .footer-content {
    cursor: pointer;
    width: 100%;
    text-align: center;
    color: #2d53da;
    background: #e3e8fc;
    border-radius: 5px;
    padding: 8px 0;
  }
  .breadcrumb {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .lite-text {
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
`;

const KPIPlaceholder = styled.div`
  background: #e9eeff;
  border-radius: 6px;
  padding: 40px;
  text-align: center;
  color: #3f4d7a;
  margin-top: 16px;
`;

const AddEditKPI = ({ status = false }) => {
  const userInfo = useSelector(getUserInfo);
  const [form] = Form.useForm();
  const history = useHistory();
  const location = useLocation();
  const departmentList = useSelector(getAllDepartmentList);
  const dataList = location?.state?.data || {};
  console.log("datalist-->", dataList);
  const loadNewList = useSelector(getLoadNewList);
  const [loading, setLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [activeTemplate, setActiveTemplate] = useState({});
  console.log("templateList-->", activeTemplate);
  const [tableData, setTableData] = useState([]);
  console.log("tabledada-->", tableData);
  const [weightageError, setWeightageError] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [invalidFields, setInvalidFields] = useState({
    strategic: [],
    previous: [],
    upcoming: [],
    bdo: [],
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (dataList) {
      form.setFieldsValue({
        ...dataList,
        attendstartdate: dataList?.attendstartdate
          ? dayjs(dataList.attendstartdate)
          : null,
      });
    }
    if (dataList?.kpirole?.length > 0) {
      setTableData(dataList?.kpirole);
    }
  }, [dataList]);

  const fetchTemplateData = async () => {
    try {
      const { templates, code } = await CALL_API(
        `performance/performancetemplate/templates`,
        "get"
      );
      if (code === STATUS_CODE.SUCCESS) {
        setTemplateList(templates);
      } else {
        throw new Error(`Failed to fetch data: ${code}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleTableDataChange = (index, field, value) => {
    const updated = tableData.map((item, idx) =>
      idx === index ? { ...item, [field]: value } : item
    );
    setTableData(updated);
    if (field === "weightage") {
      const total = updated.reduce(
        (sum, item) => sum + (parseFloat(item.weightage) || 0),
        0
      );

      setWeightageError(
        total !== 100 ? "Total weightage must be exactly 100%" : ""
      );
    }

    // Clear validation error for this field
    setInvalidFields((prev) => {
      const updated = { ...prev };
      if (updated.strategic.includes(index)) {
        if (value) {
          updated.strategic = updated.strategic.filter((i) => i !== index);
        }
      }
      return updated;
    });

    // Check if current row is complete and is the last row
    const currentRow = updated[index];
    const isLastRow = index === updated.length - 1;
    const isCurrentRowComplete =
      currentRow.kpicategory !== "" &&
      currentRow.kpicategory !== null &&
      currentRow.kpidescription !== "" &&
      currentRow.kpidescription !== null &&
      currentRow.expectedoutcomes !== "" &&
      currentRow.expectedoutcomes !== null &&
      currentRow.weightage !== "" &&
      currentRow.weightage !== null;

    // Auto-add new row if current row is complete, it's the last row, and we haven't reached 10 rows
    // if (isLastRow && isCurrentRowComplete && tableData.length < 10) {
    //   const newRow = {
    //     id: updated.length + 1,
    //     kpicategory: "",
    //     kpidescription: "",
    //     expectedoutcomes: "",
    //     weightage: "",
    //   };
    //   setTableData([...updated, newRow]);
    // }
  };

  const handleAddRow = () => {
    const lastRow = tableData[tableData.length - 1];

    // Check if last row is complete
    if (
      (!lastRow ||
        !lastRow.kpicategory ||
        !lastRow.kpidescription ||
        !lastRow.expectedoutcomes ||
        !lastRow.weightage) &&
      tableData?.length
    ) {
      message.error(
        "Please complete all fields in the current row before adding another"
      );
      // Highlight the incomplete row
      if (lastRow) {
        setInvalidFields((prev) => ({
          ...prev,
          strategic: [...prev.strategic, tableData.length - 1],
        }));
      }
      return;
    }

    const newRow = {
      id: tableData.length + 1,
      kpicategory: "",
      kpidescription: "",
      expectedoutcomes: "",
      weightage: "",
    };

    setTableData([...tableData, newRow]);
  };

  const handleDeleteRow = (id) => {
    const filteredData = tableData.filter((item) => item.id !== id);

    const updatedData = filteredData.map((item, index) => ({
      ...item,
      id: index + 1,
    }));

    setTableData(updatedData);

    // Recalculate weightage after deletion
    const total = updatedData.reduce(
      (sum, item) => sum + (parseFloat(item.weightage) || 0),
      0
    );

    if (updatedData.length === 0) {
      setWeightageError("");
    } else {
      setWeightageError(
        total !== 100 ? "Total weightage must be exactly 100%" : ""
      );
    }
  };

  const validateTable = () => {
    let isValid = true;
    const invalidRows = [];

    // Check if table has at least one row
    if (tableData.length === 0) {
      message.error("Please add at least one KPI row");
      return false;
    }

    // Validate all rows
    tableData.forEach((row, index) => {
      if (
        !row.kpicategory ||
        !row.kpidescription ||
        !row.expectedoutcomes ||
        !row.weightage
      ) {
        invalidRows.push(index);
        isValid = false;
      }
    });

    // Update validation state
    setInvalidFields((prev) => ({
      ...prev,
      strategic: invalidRows,
    }));

    // Check weightage total
    const total = tableData.reduce(
      (sum, item) => sum + (parseFloat(item.weightage) || 0),
      0
    );

    if (total !== 100) {
      setWeightageError("Total weightage must be exactly 100%");
      isValid = false;
    }

    if (!isValid) {
      message.error(
        "Please fill in all required fields and ensure weightage totals 100%"
      );
    }

    return isValid;
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
      width: "10%",
    },
    {
      title: <div style={{ whiteSpace: "wrap" }}>KPI Category</div>,
      dataIndex: "kpicategory",
      key: "kpicategory",
      width: "30%",
      render: (text, record, index) => (
        <>
          {status === "view" ? (
            record?.kpicategory
          ) : (
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 6 }}
              value={record?.kpicategory}
              style={{
                width: "100%",
                border:
                  invalidFields.strategic.includes(index) && !record.kpicategory
                    ? "1px solid red"
                    : "",
              }}
              status={
                invalidFields.strategic.includes(index) && !record.kpicategory
                  ? "error"
                  : ""
              }
              onChange={(e) =>
                handleTableDataChange(index, "kpicategory", e.target.value)
              }
            />
          )}
        </>
      ),
    },
    {
      title: "KPI Name & Description",
      dataIndex: "kpidescription",
      key: "kpidescription",
      width: "30%",
      render: (text, record, index) => (
        <>
          {status === "view" ? (
            record?.kpidescription
          ) : (
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 6 }}
              value={record?.kpidescription}
              style={{
                width: "100%",
                border:
                  invalidFields.strategic.includes(index) &&
                  !record.kpidescription
                    ? "1px solid red"
                    : "",
              }}
              status={
                invalidFields.strategic.includes(index) &&
                !record.kpidescription
                  ? "error"
                  : ""
              }
              onChange={(e) =>
                handleTableDataChange(index, "kpidescription", e.target.value)
              }
            />
          )}
        </>
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedoutcomes",
      key: "expectedoutcomes",
      width: "30%",
      render: (text, record, index) => (
        <>
          {status === "view" ? (
            record?.expectedoutcomes
          ) : (
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 6 }}
              value={record?.expectedoutcomes}
              style={{
                width: "100%",
                border:
                  invalidFields.strategic.includes(index) &&
                  !record.expectedoutcomes
                    ? "1px solid red"
                    : "",
              }}
              status={
                invalidFields.strategic.includes(index) &&
                !record.expectedoutcomes
                  ? "error"
                  : ""
              }
              onChange={(e) =>
                handleTableDataChange(index, "expectedoutcomes", e.target.value)
              }
            />
          )}
        </>
      ),
    },
    {
      title: "Weightage (%)",
      dataIndex: "weightage",
      key: "weightage",
      width: "10%",
      render: (text, record, index) => (
        <>
          {status === "view" ? (
            record?.weightage
          ) : (
            <Input
              value={record?.weightage}
              style={{
                border:
                  invalidFields.strategic.includes(index) && !record.weightage
                    ? "1px solid red"
                    : "",
              }}
              status={
                invalidFields.strategic.includes(index) && !record.weightage
                  ? "error"
                  : ""
              }
              onKeyDown={(event) => {
                if (
                  !/[0-9]/.test(event.key) &&
                  event.key !== "Backspace" &&
                  event.key !== "Tab"
                ) {
                  event.preventDefault();
                }
              }}
              onChange={(e) =>
                handleTableDataChange(index, "weightage", e.target.value)
              }
            />
          )}
        </>
      ),
    },
    {
      title: "",
      key: "action",
      render: (text, record, index) => {
        const isLastRow = tableData[tableData.length - 1]?.id === record.id;
        return (
          tableData?.length !== 1 && (
            <DeleteOutlineOutlined
              disabled={tableData?.length === 1}
              onClick={() => handleDeleteRow(record.id)}
              style={{ color: "#2D53DA", cursor: "pointer" }}
            >
              Delete
            </DeleteOutlineOutlined>
          )
        );
      },
    },
  ];

  const onSubmitClick = async (Status) => {
    const values = form.getFieldsValue();
    if (!values.title) {
      message.error("Please enter a title before saving as draft");
      return;
    }
    if (Status === "draft") {
      setUpdateStatus("draft");
      setDraftLoading(true);
    } else {
      setSubmitLoading(true);
    }
    const payload = {
      fullname: values?.fullname,
      appraiseeuserid: dataList?.appraiseeuserid,
      appraiseruserid: dataList?.appraiseruserid,
      hireddate: values?.hireddate,
      basedepartmentid: dataList?.basedepartmentid,
      type: values?.type,
      title: values?.title,
      attendstartdate: values?.attendstartdate?.format("YYYY-MM-DD"),
      templateid: values?.templateid,
      kpirole: tableData,
      kpistatus: Status === "draft" ? "0" : "1",
      appraiserintroductorysection:
        activeTemplate?.appraiserintroductorysection || [],
      mainquestionnairesection: activeTemplate?.mainquestionnairesection || [],
      introductorysection: activeTemplate?.introductorysection || [],
      remarkssection: activeTemplate?.remarkssection || [],
      appraisermainquestionnairesection:
        activeTemplate?.appraisermainquestionnairesection || [],
      appraiserremarkssection: activeTemplate?.appraiserremarkssection || [],
      scoreclassification: activeTemplate?.scoreclassification || [],
      salaryincpercentage: activeTemplate?.salaryincpercentage || [],
      templatename: activeTemplate?.templatename || "",
      reviewstatus: "0",
      attendstatus: "0",
      departmentname: dataList?.departmentname,
    };

    if (dataList?.kpistatus === "1") {
      payload.kpiupdatedat = dayjs().format("YYYY-MM-DD");
      payload.kpiupdatedby = userInfo?.userid;
    }

    console.log("payload-->", payload, status);
    const { code } = await CALL_API(
      status === "edit" || dataList?.id
        ? `performance/addkpi/${dataList?.id}`
        : `performance/addkpi`,
      status === "edit" || dataList?.id ? "patch" : "post",
      payload
    );
    if (code === STATUS_CODE.SUCCESS) {
      setPopupOpen(true);
      dispatch(
        setLoadNewList(
          loadNewList?.filter(
            (item) => item?.appraiseeuserid !== dataList?.appraiseeuserid
          )
        )
      );
      setTimeout(() => {
        setPopupOpen(false);
        setUpdateStatus("");
        history.push("/performance", { id: "2" });
      }, 2000);
      setDraftLoading(false);
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplateData();
  }, []);
  useEffect(() => {
    setActiveTemplate(
      templateList?.find(
        (item) => item?.templateid === form.getFieldValue("templateid")
      )
    );
  }, [form.getFieldValue("templateid"), templateList]);

  const footerStyle = {
    position: "sticky",
    bottom: -20,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  const filteredTemplates = templateList?.filter(
    (item) =>
      item?.templatestatus === "Active" &&
      item?.statusid === "1" &&
      item?.availabledepartments?.includes(dataList?.basedepartmentid)
  );

  console.log("filteredTemplates", filteredTemplates);

  // Check if current template exists in filtered (active) list
  const isTemplateActive = filteredTemplates?.some(
    (item) => item?.templateid === dataList?.templateid
  );

  const mergedOptions = useMemo(() => {
    if ((status === "edit" || dataList?.id) && !isTemplateActive) {
      return [
        ...(filteredTemplates || []),
        {
          templateid: dataList?.templateid,
          templatename: dataList?.templatename,
          kpirole: dataList?.kpirole || [],
        },
      ];
    }
    return filteredTemplates || [];
  }, [filteredTemplates, dataList, templateList, status]);

  console.log("filteredTemplates", isTemplateActive);
  console.log("filteredTemplates", mergedOptions);

  return (
    <Wrapper>
      <div className="breadcrumb">
        <p
          className="lite-text p-0 m-0"
          onClick={() => history.push("/performance", { id: "2" })}
        >
          Performance
        </p>
        &nbsp;
        <RightOutlined className="mt-1" />
        &nbsp;
        <p className="m-0 p-0">
          {dataList?.kpistatus === "1" ? "Edititng KPIs" : "Adding KPIs"}
        </p>
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={(values) => {
          if (validateTable()) {
            onSubmitClick("submit");
          }
        }}
      >
        <Row gutter={24}>
          {/* Left Column */}
          <Col xs={24} sm={24} md={12}>
            <Form.Item name="fullname" label="Name of the employee">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item name="hireddate" label="Hired Date">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item name="departmentname" label="Department">
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="type"
              label="Type"
              rules={[{ required: true, message: "Type is Required" }]}
            >
              <Select>
                <Option value="Yearly Appraisal">Yearly Appraisal</Option>
                <Option value="Half Yearly Appraisal">
                  Half Yearly Appraisal
                </Option>
                <Option value="Quarterly Appraisal">Quarterly Appraisal</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="title"
              label="Title"
              rules={[{ required: true, message: "Title is Required" }]}
            >
              <Input placeholder="Title" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="attendstartdate"
              label="Start date to attend appraisal"
              rules={[{ required: true, message: "Start date is Required" }]}
            >
              <DatePicker style={{ width: "100%" }} format={"DD-MM-YYYY"} />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <h6>KPI for the Appraisal Period</h6>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="templateid"
              label="Choose the KPI Template"
              rules={[{ required: true, message: "Template is Required" }]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                placeholder="Choose the KPI Template"
                options={mergedOptions}
                fieldNames={{
                  label: "templatename",
                  value: "templateid",
                }}
                value={dataList?.templateid ?? undefined}
                onChange={(values) => {
                  setTableData(
                    mergedOptions?.find((item) => item?.templateid === values)
                      ?.kpirole
                  );
                  setActiveTemplate(
                    mergedOptions?.find((item) => item?.templateid === values)
                  );
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* KPI Section */}
        {form.getFieldValue("templateid") ? (
          <>
            <StyledTable
              dataSource={tableData}
              columns={columns}
              className="small_table mb-3"
              rowKey="key"
              pagination={false}
            />
            {weightageError && (
              <div style={{ color: "red" }}>{weightageError}</div>
            )}
            <div className="footer-content mb-3" onClick={handleAddRow}>
              + Add another row
            </div>
            <div style={footerStyle}>
              <ButtonOutlined
                onClick={() => {
                  history.push("/performance", { id: "2" });
                }}
              >
                Cancel
              </ButtonOutlined>
              {dataList?.kpistatus !== "1" && (
                <ButtonOutlined
                  loading={draftLoading}
                  type="primary"
                  onClick={() => {
                    onSubmitClick("draft");
                  }}
                >
                  Save as Draft
                </ButtonOutlined>
              )}
              <ButtonFilled
                loading={submitLoading}
                type="primary"
                htmlType="submit"
              >
                {dataList?.kpistatus === "1" ? "Update" : "Complete"}
              </ButtonFilled>
            </div>
          </>
        ) : (
          <KPIPlaceholder>
            Choose a KPI Template in the above section to Customize
          </KPIPlaceholder>
        )}
      </Form>
      <SuccessDeclinePopup
        open={popupOpen}
        setOpen={setPopupOpen}
        type="success"
        message={
          dataList?.kpistatus === "1"
            ? "Updated"
            : updateStatus === "draft"
            ? "Drafted"
            : "Completed"
        }
      />
    </Wrapper>
  );
};

export default AddEditKPI;
